import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { routes } from './shared.routes';
import { RouteNotFoundComponent } from './route-not-found/route-not-found.component';
import { LogErrorHandler } from './error-handler/error-handler';
import { LogService } from './log/log.service';
import { ConsoleLogSubscriberService } from './log/console-log-subscriber.service';
import { ErrorHandlerService } from './utils/error-handler.service';
import { HttpLogSubscriberService } from './log/http-log-subscriber.service';
import { FlashMessagesComponent } from './flash-messages/component/flash.messages.component';
import { FlashMessagesService } from './flash-messages/service/flash.messages.service';
import { PropertyLookupStore } from './lookup/property-lookup/property-lookup.store';
import { PropertyLookupHttpService } from './lookup/property-lookup/property-lookup.http.service';
import { AgencyLookupStore } from './lookup/agency-lookup/agency-lookup.store';
import { AgencyLookupHttpService } from './lookup/agency-lookup/agency-lookup.http.service';
import { BootstrapModule } from './bootstrap/bootstrap.module';
import { FormInputComponent } from './form-input/form-input.component';
import { ValidationMessageComponent } from './validation-message/validation-message.component';
import { InlineSearchComponent } from './inline-search/inline-search.component';
import { Ng2PageScrollModule } from 'ng2-page-scroll';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { GenericErrorComponent } from './generic-error/generic-error.component';

// Add RXJS operators so that they can be used throughout the app
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/observable/interval';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/never';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/concat';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/switch';
import { VersionComponent } from './version/version.component';
import { VersionStore } from './version/service/version.store';
import { VersionHttpService } from './version/service/version.http.service';
import { PermissionModule } from '../permission/permission.module';
import { ReservationStatusPipe } from './pipes/reservation-status.pipe';
import { PaymentStatusPipe } from './pipes/payment-status.pipe';
import { EnvironmentModule } from '../environment/environment.module';
import { EnvironmentConfiguration } from '../environment/services/environment.configuration';
import { AbsoluteValuePipe } from './pipes/absolute-value.pipe';
import { AdjustmentTypePipe } from './pipes/adjustment-type.pipe';

@NgModule({
  imports: [
    CommonModule,
    BootstrapModule,
    TranslateModule,
    FormsModule,
    PermissionModule,
    EnvironmentModule,
    RouterModule.forChild(routes),
    Ng2PageScrollModule.forRoot()
  ],
  exports: [
    CommonModule,
    BootstrapModule,
    TranslateModule,
    InlineSearchComponent,
    FlashMessagesComponent,
    FormInputComponent,
    ValidationMessageComponent,
    Ng2PageScrollModule,
    ConfirmationModalComponent,
    VersionComponent,
    PermissionModule,
    EnvironmentModule,
    PaymentStatusPipe,
    ReservationStatusPipe,
    AbsoluteValuePipe,
    AdjustmentTypePipe
  ],
  declarations: [
    ConfirmationModalComponent,
    RouteNotFoundComponent,
    InlineSearchComponent,
    FlashMessagesComponent,
    FormInputComponent,
    ValidationMessageComponent,
    VersionComponent,
    GenericErrorComponent,
    PaymentStatusPipe,
    ReservationStatusPipe,
    AbsoluteValuePipe,
    AdjustmentTypePipe
  ],
  providers: [
    AgencyLookupHttpService,
    AgencyLookupStore,
    ErrorHandlerService,
    LogService,
    ConsoleLogSubscriberService,
    FlashMessagesService,
    HttpLogSubscriberService,
    PropertyLookupHttpService,
    PropertyLookupStore,
    VersionStore,
    VersionHttpService,
    { provide: ErrorHandler, useClass: LogErrorHandler }
  ]
})
export class SharedModule {
  constructor(consoleLogSubscriber: ConsoleLogSubscriberService,
              httpLogSubscriber: HttpLogSubscriberService,
              environment: EnvironmentConfiguration) {
    if (environment.logServices.consoleLogSubscriber) {
      consoleLogSubscriber.init(environment.logServices.consoleLogSubscriber.logLevel);
    }

    if (environment.logServices.httpLogSubscriber) {
      httpLogSubscriber.init(environment.logServices.httpLogSubscriber.logLevel);
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/shared.module.ts